module.exports = __webpack_public_path__ + "img/speed.762660ff.svg";